import { StockOptions } from 'results/constants'

export const stockOptionI18nKey = (option: StockOptions): string => {
  switch (option) {
    case StockOptions.SHOW_ALL:
      return 'stockOptionAll'
    case StockOptions.ONLY_PRICED:
      return 'Only Priced'
    case StockOptions.ONLY_STOCKED:
      return 'stockOptionInStock'
    default:
      return 'stockOptionAll'
  }
}
